import styled from "styled-components";
import { Button } from "./Button.styled";

export const MiniBanner = styled.div`
  width: 100%;
  height: 32rem;
  background-image:
    linear-gradient(0deg, rgba(215, 242, 254, 0.3), rgba(215, 242, 254, 0.3)),
    linear-gradient(
      180deg,
      rgba(215, 242, 254, 0) 70%,
      rgba(215, 242, 254, 0.8) 100%
    ),
    linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 73.11%,
      rgba(215, 242, 254, 0.8) 98.89%
    ),
    linear-gradient(
      90deg,
      rgba(215, 242, 254, 0) 77.66%,
      rgba(215, 242, 254, 0.8) 100%
    ),
    url("/assets/kitchen.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  z-index: 10;
  box-shadow: 0 16px 22px rgba(0, 0, 0, 0.2);

  .banner-rating {
    background-color: #fff;
    padding: 0.75rem 1.5rem;
    border-radius: 30px;
    position: absolute;
    top: 3rem;
    z-index: 4;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    img {
      position: static;
      max-height: none;
    }
  }

  .hero-content {
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
    z-index: 2;

    h1 {
      background-color: #fff;
      padding: 2rem 8rem;
      border-radius: 30px;
      margin: 0;
      font-size: 48px;
      line-height: 64px;
      font-weight: 800;
      letter-spacing: -1.08px;
      color: #000;
      z-index: 2;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      position: relative;

      .mobile-break {
        display: none;
      }
    }

    > img {
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      max-height: 500px;
      object-fit: contain;
      z-index: 3;
    }
  }

  @media (max-width: 768px) {
    height: 300px;

    .banner-rating {
      padding: 0.5rem 1rem;
      top: 15px;
    }

    .hero-content {
      width: 95%;

      > img {
        max-height: 220px;
      }

      h1 {
        font-size: 32px;
        line-height: normal;
        letter-spacing: normal;
        padding: 1rem 2rem;
        margin: 0 2rem;
        font-weight: 800;
        text-align: center;
      }
    }
  }

  @media (max-width: 460px) {
    height: 280px;
    .banner-rating {
      padding: 0.4rem 0.8rem;
    }

    .hero-content {
      width: 85%;

      > img {
        max-height: 180px;
      }

      h1 {
        font-size: 32px;
        line-height: normal;
        letter-spacing: normal;
        padding: 1rem 2rem;
        margin: 0 2rem;
        font-weight: 800;
        margin-bottom: 50px;

        .mobile-break {
          display: block;
        }
      }
    }
  }
`;

export const ZipcodeSection = styled.div`
  text-align: center;
  background-color: #35c0fc;
  padding-top: 98px;
  padding-bottom: 48px;

  h1 {
    font-weight: 800;
    font-size: 48px;
  }

  p {
    font-weight: 600;
    font-size: 18px;
    color: rgba(33, 33, 33, 0.52);
    margin-top: 24px;
    margin-bottom: -4px;
  }

  @media (max-width: 768px) {
    padding-top: 93px;

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 16px;
    }
  }

  @media (max-width: 460px) {
    padding-top: 60px;
    padding-bottom: 12px;

    h1 {
      font-size: 36px;
    }

    p {
      font-size: 16px;
      margin-top: 20px;
    }
  }
`;

export const ZipcodeCol = styled.div`
  @media (max-width: 460px) {
    width: 100%;
    position: relative;

    input.form-control {
      margin: 0 auto;
    }

    #utility-dropdown {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -140px;
      z-index: 1;
    }

    #utility-dropdown .dropdown-toggle {
      box-sizing: border-box;
    }
  }
`;

export const ZipcodeRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }

  input.form-control {
    padding: 1rem 2rem;
    background-color: #fff;
    border-radius: 50px;
    border: 1px solid #eaecf0;
    font-size: 16px;
    font-weight: 600;
    min-width: 175px;
    box-sizing: border-box;

    &::placeholder {
      font-weight: 500;
      color: #000;
    }
  }

  ${Button} {
    padding: 1rem 2rem;
    margin-left: 24px;
  }

  @media (max-width: 460px) {
    input.form-control {
      width: 100%;
    }
    flex-direction: row;
    margin: 20px 0.5rem 32px;
    align-items: center;

    ${Button} {
      margin-left: 8px;
      white-space: nowrap;
    }
  }
`;

export const PlansSection = styled.div`
  background: #35c0fc;
`;

export const RenewalFeaturesSection = styled.div`
  margin: 40px 0 100px;
  border-radius: 24px;
  border: 1px solid #f2f2f2;
  background-color: #fff;
`;

export const RenewalFeaturesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 24px;
  padding: 40px 20px;
  gap: 20px;

  /* &:last-child {
        border-bottom: 0 none;
    } */

  & > div {
    display: flex;
    text-align: left;
    flex: 1;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #3a3a3a1a;
    border-radius: 32px;
    padding: 24px;
    min-width: calc(50% - 10px);
  }

  & > div:last-child {
    margin-left: 0;
  }

  p {
    font-size: 14px;
    padding: 0 8px;
    margin: 0;
  }

  @media (max-width: 768px) {
    gap: 16px;

    & > div {
      flex: 0 0 calc(50% - 8px);
      min-width: calc(50% - 8px);
    }
  }
`;

export const ReviewsSectionHeading = styled.div`
  h2 {
    margin: 0 0 16px;
    font-size: 48px;
    font-weight: 800;
    text-align: center;
  }

  p {
    text-align: center;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 32px;
    }

    p {
      font-size: 14px;
    }
  }
`;

export const ReviewsWrapper = styled.div`
  padding: 3.5rem 0px 0px 8.68vw;
`;

export const ReviewsContainer = styled.div`
  @keyframes slide {
    from {
      -webkit-transform: translateX(0%);
      -ms-transform: translateX(0%);
      transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }

  display: inline-flex;
  width: calc(184rem);
  animation: 56s linear 0s infinite normal both running slide;

  &:hover {
    animation-play-state: paused;
  }

  @media (max-width: 767.98px) {
    width: calc(136rem);
  }
`;

export const ReviewBox = styled.div`
  padding: 2.8125rem 0.5rem 3.5rem;
  min-width: 23rem;
  text-align: left;
  box-sizing: border-box;

  @media (max-width: 767.98px) {
    padding-top: 2.125rem;
    min-width: 17rem;
  }
`;

export const ReviewInner = styled.div`
  background: #fff;
  border: 3px solid #ffe9ee;
  box-shadow: rgb(224 224 224 / 20%) 0px 9px 30px;
  border-radius: 24px;
  padding: 0px 2.625rem 3.625rem 3.375rem;
  display: flex;
  flex-direction: column;
  min-height: 27.5rem;
  height: 27.5rem;
  max-height: 100%;
  transition: transform 0.25s ease 0s;
  box-sizing: border-box;

  &:hover {
    transform: scale(1.015);
  }

  @media (min-width: 768px) and (max-width: 1199.98px) {
    min-height: 25rem;
    height: 25rem;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    padding: 0px 1.625rem 3.625rem 2.375rem;
  }

  @media (max-width: 767.98px) {
    padding: 0px 1.875rem 2.625rem 2.5rem;
    min-height: 22rem;
    height: 22rem;
  }
`;

export const ReviewThumbnail = styled.div`
  width: 89px;
  height: 89px;
  border-radius: 50%;
  position: relative;
  margin: -2.8125rem 0px 1.5rem;
  flex-shrink: 0;

  span {
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    width: initial;
    height: initial;
    background: none;
    opacity: 1;
    border: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    padding: 0;
    border: none;
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media (max-width: 767.98px) {
    width: 66px;
    height: 66px;
    margin: -2.125rem 0px 1.125rem;
  }
`;

export const Reviewer = styled.div`
  h5 {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 28px;
    letter-spacing: -0.28px;
    color: #3a3a3a;
    margin-bottom: 0.25rem;
    margin-top: 0;
  }

  p {
    font-size: 0.875rem;
    line-height: 20px;
    color: #0bcebb;
    margin-bottom: 0;
  }

  p a {
    text-decoration: none;
    color: #0bcebb;
  }

  @media (min-width: 768px) and (max-width: 1199.98px) {
    h5 {
      font-size: 1.125rem;
      line-height: 22px;
    }
  }

  @media (max-width: 767.98px) {
    h5 {
      font-size: 1rem;
      line-height: 21px;
      letter-spacing: -0.2px;
    }
  }

  @media (max-width: 1199.98px) {
    p {
      font-size: 0.75rem;
    }
  }
`;

export const ReviewRank = styled.div`
  margin: 1.25rem 0px 1.375rem;

  @media (max-width: 767.98px) {
    margin: 1rem 0px 1.125rem;
  }
`;

export const ReviewComment = styled.div`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 30px;
  letter-spacing: -0.35px;
  color: #3a3a3a;

  @media (min-width: 768px) and (max-width: 1199.98px) {
    font-size: 1.125rem;
    line-height: 26px;
  }

  @media (max-width: 767.98px) {
    font-size: 1rem;
    line-height: 22px;
    letter-spacing: -0.26px;
  }
`;

export const RenewalPlanList = styled.div`
  display: flex;
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  padding: 24px 100px;
  justify-content: space-between;
  flex-wrap: wrap;
  /* row-gap: 20px; */
  box-sizing: border-box;
  position: relative;

  .swiper-pagination-bullet {
    cursor: pointer;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 100%;
    padding: 24px 100px;
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
  }

  @media (max-width: 540px) {
    padding: 12px 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

interface RenewalPlanItemProps {
  recommended: boolean;
}

export const RenewalPlanItem = styled.div<RenewalPlanItemProps>`
  /* width: 31%; */
  padding: 12px 8px;
  border-radius: 28px;
  position: relative;
  background-color: ${({ recommended, theme }) =>
    recommended ? theme.colors.secondary : "transparent"};

  &::after {
    display: ${({ recommended }) => (recommended ? "inline-block" : "none")};
    content: "Recommended";
    position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 700;
    color: #fff;
    font-size: 13px;
    background: url("/static/images/recommend-star.png") 0 0 no-repeat;
    background-size: 11px;
    padding-left: 16px;
  }

  /* @media (max-width: 1125px) {
        width: 48%;
    } */

  /* @media (max-width: 540px) {
        width: 100%;
    } */
`;

interface RenewalPlanItemInnerProps {
  isPopular?: boolean;
}

export const RenewalPlanItemInner = styled.div<RenewalPlanItemInnerProps>`
  transition: all 0.3s;
  background-color: #fff;
  border: 1px solid #eaecf0;
  border-radius: 24px;
  position: relative;
  box-shadow: 0px 9px 15px rgba(224, 224, 224, 0.4);
  text-align: center;
  padding: 1rem 0;
  padding-bottom: 2rem;
  &:hover {
    transform: scale(1.02);
    border-color: #ff5a6a;
  }
`;

export const RenewalPlanName = styled.div`
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  padding: 8px 0;

  b {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;

    b {
      font-size: 18px;
    }
  }
`;

export const RenewalPlanPrice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;

  & > div {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  & > span {
    color: rgba(33, 33, 33, 0.52);
    text-align: center;
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: -0.32px;
    vertical-align: middle;
  }

  b > span {
    font-size: 48px;
    line-height: 1.2;
  }

  i {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
  }

  @media (max-width: 768px) {
    b > span {
      font-size: 32px;
    }
  }
`;

export const RenewalPlanPriceLabel = styled.span`
  display: block;
  text-align: left;
  font-size: 15px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const RenewalPlanPriceLeft = styled(RenewalPlanPrice)`
  align-items: flex-start;
  text-align: left;

  & > div {
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;

    & > div {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }

    .kwh-label {
      font-size: 15px;
      font-weight: 600;
      color: rgba(33, 33, 33, 0.52);
      margin-bottom: 6px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }

  & > span {
    text-align: left;
    font-size: 15px;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export const RenewalPlanAction = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 20px;

  ${Button} {
    flex: 1;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const RenewalPlanInfo = styled.div`
  padding: 16px 24px 24px;
`;

export const RenewalPlanLabel = styled.span`
  leading-trim: none;
  line-height: 24px;
  letter-spacing: -0.32px;
  font-size: 15px;
  font-weight: 700;
  color: #000000;
  padding: 0.5rem 1rem;
  display: inline-block;
  width: auto;
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: 12px;
`;

export const RenewalPlanRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;

  label {
    display: inline-flex;
    font-weight: normal;
    font-size: 15px;
    align-items: center;
    color: rgba(58, 58, 58, 0.7);

    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }

  span {
    text-align: right;
    font-weight: 700;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    label {
      font-size: 14px;
    }

    span {
      font-size: 14px;
    }
  }

  .renewal-tooltip-theme {
    width: 160px;
    line-height: 1.5;
    font-size: 13px;
    border-radius: 8px !important;
    opacity: 1 !important;
    color: #333;
    background-color: rgba(255, 255, 255, 0.95);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: left;
  }

  .renewal-tooltip-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    mask-image: url("../images/questionmark.svg");
    mask-size: cover;
    background-color: #98a2b3;
    margin-left: 4px;
    flex-shrink: 0;
  }
`;

export const RenewalPlanDetailSection = styled.div`
  margin: 20px 0;
  border: 1px solid #ffdee1;
  border-radius: 24px;
  background-color: #fff9f9;
  padding: 12px 20px;
`;

export const RenewalPlanIncludes = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #eaecf0;
  text-align: left;

  h4 {
    font-weight: 700;
    font-size: 20px;
    margin: 0 0 12px 0;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    font-size: 12px;
    color: rgba(58, 58, 58, 0.7);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      margin-right: 4px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 768px) {
    h4 {
      font-size: 18px;
    }
  }
`;

export const RenewalPlanDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  color: #475467;
  font-size: 13px;

  label {
    font-weight: 700;
  }
`;

export const RenewalPlanDetailFooter = styled.div`
  border-top: 1px solid rgba(33, 33, 33, 0.1);
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  display: flex;

  ${Button} {
    background-color: #fff;
  }
`;

export const PlanDocLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondary};
  text-decoration: none;
  font-size: 16px;
  padding: 8px 0;

  ::before {
    content: " ";
    display: block;
    width: 16px;
    height: 16px;
    mask-image: url("/images/LinkExternal.svg");
    background-color: ${({ theme }) => theme.colors.secondary};
    mask-size: cover;
    margin-right: 8px;
  }
`;

export const RenewalPlanDetailLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;

  ${PlanDocLink} {
    margin-right: 12px;
    color: #ff5b6a;
    font-size: 14px;

    &::before {
      width: 14px;
      height: 14px;
      background-color: #ff5b6a;
    }

    &::after {
      display: inline-block;
      width: 1px;
      height: 12px;
      content: " ";
      background-color: rgba(33, 33, 33, 0.1);
      margin-left: 12px;
    }

    &:last-child::after {
      display: none;
    }
  }
`;

export const RenewalPlanDetailContent = styled.div`
  display: flex;
  flex-direction: row-reverse;
  text-align: left;
  gap: 40px;
  padding: 0 2rem;
  background-color: #fff;

  @media (max-width: 540px) {
    flex-direction: column-reverse;
    padding: 0 20px;
    gap: 0;
  }
`;

export const RenewalPlanDetailInfo = styled.div`
  flex: 1;

  h4 {
    font-size: 20px;
    font-weight: 700;
    font-style: bold;
    line-height: 28px;
    letter-spacing: 0px;
  }
`;

export const RenewalPlanNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  h4 {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    flex: 1;
  }

  @media (max-width: 540px) {
    justify-content: space-between;

    h4 {
      font-size: 20px;
    }
  }
`;

export const RenewalPlanDetailFacts = styled.div`
  flex: 1;
  margin-top: 2rem;
  margin-left: 2rem;

  ${RenewalPlanPrice} {
    /* margin-top: 60px; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;

    & > div {
      align-items: flex-end;
      justify-content: flex-start;
    }
  }

  ${RenewalPlanPriceLeft} {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;

    & > div {
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;
    }

    & > span {
      text-align: left;
      font-size: 14px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: normal;
      vertical-align: baseline;
    }

    b > span {
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.2;
    }
  }

  ${RenewalPlanInfo} {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    border-top: 0 none;
    margin-top: 0;
  }

  @media (max-width: 540px) {
    margin-left: 0;
    width: 100%;

    ${RenewalPlanPrice} {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 20px;

      span {
        margin-left: 0;
      }
    }
  }
`;

export const RenewalPlanDetailPriceTable = styled.div`
  font-size: 14px;
  margin-bottom: 40px;
  margin-top: 42px;
`;

export const RenewalPlanDetailPriceThead = styled.div`
  display: flex;

  span {
    display: inline-block;
    flex: 1;
    margin-bottom: 20px;
  }
`;

export const RenewalPlanDetailPriceTbody = styled.div`
  background-color: rgba(243, 243, 243, 0.5);
  border-radius: 12px;

  & > div {
    display: flex;
    border-bottom: 1px solid #f2f2f2;
  }

  & > div:last-child {
    border-bottom: 0 none;
  }

  span {
    display: inline-block;
    flex: 1;
    padding: 12px 20px;
    box-sizing: border-box;
  }

  span:last-child {
    border-right: 0 none;
  }
`;

export const RenewalPlanDetailDocs = styled.div`
  display: flex;
  flex-direction: column;

  ${PlanDocLink} {
    color: #ff5b6a;

    &::before {
      background-color: #ff5b6a;
    }
  }
`;

export const RenewalPlanEbillLabel = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: rgba(33, 33, 33, 0.04);
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 12px;
  margin-top: 12px;
  margin-bottom: 24px;
  font-weight: 700;

  img {
    margin-right: 8px;
  }
`;

export const RenewalPlanDetailBottom = styled.div`
  border: 0 none;
  border-radius: 0 0 30px 30px;
  margin: 0;
  padding: 20px;
  background-color: #ffe9ee;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;

  > h4 {
    font-size: 20px;
    font-weight: 700;
    font-style: bold;
    line-height: 28px;
    letter-spacing: 0px;
    margin: 0;
    padding: 0 0 0 0;
  }

  ${RenewalFeaturesRow} {
    background-color: transparent;
    padding: 0;

    h4 {
      font-size: 20px;
      font-weight: 700;
      margin: 12px 0 16px;
    }
  }

  @media (max-width: 540px) {
    border-radius: 0 0 20px 20px;

    ${RenewalFeaturesRow} {
      flex-direction: column;

      & > div {
        flex: 0 0 100%;
        min-width: 100%;
      }
    }
  }
`;

export const NoDataRow = styled.div`
  height: 580px;
  text-align: center;
  color: #999;
`;

export const PlanError = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 100px;
  color: white;
`;

export const ModalBody = styled.div`
  text-align: center;
  overflow-y: auto;
  max-height: calc(90vh - 44px);
  border-radius: 0 0 30px 30px;
  background-color: #ffe9ee;

  /* Hide scrollbar but keep scrollable */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  @media (max-width: 540px) {
    border-radius: 0 0 20px 20px;
  }
`;

export const ModalTitle = styled.h2`
  color: #3a3a3a;
  font-size: 20px;
  margin-top: 16px;
  padding: 0 24px;
  text-align: center;
`;

export const ModalClose = styled.button`
  display: inline-block;
  padding: 8px;
  background-color: #f3f3f3;
  border-radius: 50%;
  cursor: pointer;
  border: 0 none;
  position: absolute;
  top: 18px;
  right: 16px;
  font-size: 0;

  ::after {
    display: inline-block;
    width: 20px;
    height: 20px;
    content: " ";
    background: url("/images/X.svg") 0 0 no-repeat;
    background-size: cover;
  }
`;

export const FaqSection = styled.div`
  margin: 50px 0;
`;

export const SectionHead = styled.div`
  text-align: center;
  margin-bottom: 50px;

  h2 {
    font-size: 48px;
    font-weight: 800;
  }

  p {
    font-size: 15px;
    color: rgba(33, 33, 33, 0.52);

    a {
      color: #35c0fc;
    }
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 32px;
    }

    p {
      font-size: 14px;
    }
  }
`;

export const FaqList = styled.div`
  max-width: 768px;
  margin: 0 auto;
`;

interface FaqListItemProps {
  isOpen: boolean;
}

export const FaqListItemQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  padding: 4px 0 8px;

  i {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const FaqListItemAnswer = styled.div`
  color: rgba(40, 40, 40, 0.7);
  max-height: 0;
  overflow: hidden;
  white-space: pre-line;
  /* transition: all .3s; */
`;

export const FaqListItemInner = styled.div`
  border-radius: 24px;
  padding: 24px;
`;

export const FaqListItem = styled.div<FaqListItemProps>`
  border-bottom: 1px solid #eee;
  padding: 12px 0;

  ${FaqListItemQuestion} {
    i {
      flex-shrink: 0;
      background-image: ${({ isOpen }) =>
        isOpen
          ? "url('/images/minus-circle.png')"
          : "url('/images/plus-circle.png')"};
      /* background-color: ${({ theme, isOpen }) =>
        isOpen ? theme.colors.primary : "rgba(33, 33, 33, 0.52)"}; */
    }
  }

  ${FaqListItemInner} {
    background-color: ${({ isOpen }) => (isOpen ? "#fff" : "transparent")};
    border: ${({ isOpen }) => (isOpen ? "1px solid #eee" : "0 none")};
    box-shadow: ${({ isOpen }) =>
      isOpen ? "0px 12px 18px -4px rgba(16, 24, 40, 0.05)" : "none"};
  }

  ${FaqListItemAnswer} {
    max-height: ${({ isOpen }) => (isOpen ? "9999px" : 0)};
  }
`;

interface SwiperBtnProps {
  various: string;
}

export const SwiperBtn = styled.button<SwiperBtnProps>`
  position: absolute;
  top: 50%;
  left: ${({ various }) => (various === "next" ? "auto" : "0")};
  right: ${({ various }) => (various === "next" ? "0" : "auto")};
  z-index: 99;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 80px;
  height: 80px;
  transform: translateY(-50%);
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    cursor: default;
    opacity: 0.3;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    position: static;
    transform: none;
    width: 80px;
    height: 80px;
    display: inline-flex;
  }

  @media (max-width: 540px) {
    width: 72px;
    height: 72px;
  }
`;

export const CommunityDesktop = styled.div`
  display: block;
  position: relative;
  padding: 0 100px;

  .swiper-pagination {
    margin-top: 24px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const CommunityMobile = styled.div`
  display: none;
  overflow: hidden;

  .swiper {
    overflow: hidden;
    padding: 0 12px;
  }

  .swiper-wrapper {
    align-items: center;
  }

  .swiper-slide {
    transition: opacity 0.3s ease;
    height: auto;

    .community-image {
      transition: height 0.3s ease;
      height: 180px;
      min-height: auto;
      flex: none;
      width: 100%;
    }
  }

  .swiper-slide:not(.swiper-slide-active) {
    opacity: 0.5;
  }

  .swiper-slide-active {
    opacity: 1;

    .community-image {
      height: 260px;
    }
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const CommunityRow = styled.div`
  margin-top: 60px;
  position: relative;

  @media (max-width: 540px) {
    margin-top: 44px;
  }
`;

export const CommunityNavBtn = styled.button<{ direction: "prev" | "next" }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === "prev" ? "left: 0;" : "right: 0;")}
  width: 80px;
  height: 80px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CommunityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  min-height: 400px;
`;

export const CommunityItemImage = styled.div`
  flex: 1;
  border-radius: 30px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 550px;

  @media (max-width: 768px) {
    min-height: 300px;
  }
`;

export const CommunityItemContent = styled.div`
  flex: 1;
  border-radius: 30px;
  background-color: #fff;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 9px 30px rgba(224, 224, 224, 0.2);

  p {
    font-size: 18px;
    line-height: 28px;
    margin: 12px 0;
  }

  @media (max-width: 768px) {
    flex: none;
    margin-top: 16px;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    p {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

export const CommunityItemContentHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;

  span {
    font-size: 18px;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    span {
      font-size: 16px;
    }
  }
`;

export const CommunityItemContentFooter = styled.div`
  h6 {
    font-size: 20px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0px;
    margin: 0.25rem 0;
  }

  p {
    font-size: 18px;
    font-weight: 600;
    margin: 4px 0 0;
    line-height: 24px;
    color: #ff5a6a;
  }

  @media (max-width: 768px) {
    h6 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
    }
  }
`;

export const NewFeatureSection = styled.div`
  p {
    margin: 0;
    padding: 0;
  }
`;

export const NewFeatureSectionInner = styled.div`
  width: 100%;
`;

export const WhySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;

  .why-item {
    position: relative;
    width: 100%;
    height: 400px;
    border-radius: 30px;
    overflow: visible;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
      border-radius: 32px;
    }

    .why-content {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: white;
      padding: 30px;
      border-radius: 32px;
      max-width: 400px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      z-index: 2;

      .why-title-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
      }

      .why-icon {
        flex-shrink: 0;
        overflow: visible;
      }

      h3 {
        font-size: 20px;
        font-weight: 700;
        margin: 0;
        color: #212121;
      }

      p {
        font-size: 15px;
        line-height: 1.6;
        margin: 0;
        color: rgba(33, 33, 33, 0.8);
      }
    }

    &:nth-child(odd) .why-content {
      left: 40px;
    }

    &:nth-child(even) .why-content {
      right: 40px;
    }
  }

  @media (max-width: 991px) {
    gap: 80px;

    .why-item {
      height: 350px;

      .why-content {
        max-width: 350px;
        padding: 25px;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 100px;
    padding-bottom: 7rem;

    .why-item {
      height: 280px;
      border-radius: 12px;
      margin-bottom: 0;

      > img {
        border-radius: 12px;
        object-position: center center !important;
      }

      .why-content {
        left: 0 !important;
        right: 0 !important;
        top: auto;
        bottom: 0;
        transform: translateY(50%);
        max-width: 100%;
        width: 100%;
        padding: 20px;
        border-radius: 12px;

        .why-title-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
        }

        .why-icon {
          flex-shrink: 0;
          overflow: visible;
        }

        h3 {
          font-size: 18px;
          margin: 0;
        }

        p {
          font-size: 14px;
        }
      }
    }
  }
`;

export const MiddleSection = styled.div`
  // background: url('/images/bg.jpg') center bottom no-repeat;
  background-size: cover;
  padding-bottom: 60px;
  background: #d7f2fe;
`;

export const TopDogsSection = styled.div`
  background-color: #86d9fd;
  padding: 80px 0;
  @media (max-width: 540px) {
    padding-top: 40px 0;
  }
`;


export const CallToActionSection = styled.section`
  background-color: rgb(53, 192, 252);
  padding: 0;

  @media (max-width: 768px) {
    padding: 48px 0;
  }
`;

export const CallToActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const CallToActionCard = styled.div`
  flex: 1;
  background: #fff;
  border-radius: 32px;
  padding: 48px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 520px;

  h2 {
    font-size: 36px;
    font-weight: 800;
    color: #000;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    color: #212121;
    margin: 0;
    max-width: 520px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 32px 24px;
    border-radius: 24px;

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 15px;
    }
  }
`;

export const CallToActionImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;
